export enum UrlPages {
    vehicle = 'vehicle',
    claim = 'claim',
    report = 'report',
    invoice = 'invoice',
    user = 'user',
    tollticket='tollticket',
    penalty='penalty'

}
